module.exports = __webpack_public_path__ + "img/一村一品.acddb369.png";